module.exports = __webpack_public_path__ + "img/02-4需求满足.5988b365.svg";